/* Elite Sports Equipment — header drawer / "All sports" panel, sport finder, bestseller tabs, quick add (26-9-2026). */
(function () {
  'use strict';
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- basket count ---------- */
  function setCount(n) {
    qsa('[data-esh-count]').forEach(function (el) { el.textContent = n; });
    qsa('[data-esh-basket]').forEach(function (el) { el.setAttribute('aria-label', 'Basket, ' + n + ' items'); });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  document.addEventListener('cart:update', refreshCount);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

  /* ---------- "All sports" panel ---------- */
  var megaBtn = document.querySelector('[data-esh-mega-toggle]');
  var mega = document.getElementById('esh-mega');
  if (megaBtn && mega) {
    var setMega = function (open) { mega.hidden = !open; megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    megaBtn.addEventListener('click', function () { setMega(mega.hidden); });
    document.addEventListener('click', function (e) { if (!mega.hidden && !mega.contains(e.target) && !megaBtn.contains(e.target)) setMega(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mega.hidden) { setMega(false); megaBtn.focus(); } });
    var mtabs = qsa('.esh-mega__tab', mega);
    var pickTab = function (t, focus) {
      mtabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    };
    var hoverT = null;
    mtabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pickTab(t); });
      t.addEventListener('mouseenter', function () { clearTimeout(hoverT); hoverT = setTimeout(function () { pickTab(t); }, 90); });
      t.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown') n = mtabs[(i + 1) % mtabs.length];
        if (e.key === 'ArrowUp') n = mtabs[(i - 1 + mtabs.length) % mtabs.length];
        if (e.key === 'Home') n = mtabs[0];
        if (e.key === 'End') n = mtabs[mtabs.length - 1];
        if (n) { e.preventDefault(); pickTab(n, true); }
      });
    });
  }

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('[data-esh-drawer]');
  var opener = document.querySelector('[data-esh-open-drawer]');
  if (drawer && opener) {
    var lastFocus = null;
    var openDrawer = function () {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('esh-lock');
      var c = drawer.querySelector('.esh-drawer__close'); if (c) c.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('esh-lock');
      if (lastFocus) lastFocus.focus();
    };
    opener.addEventListener('click', openDrawer);
    qsa('[data-esh-close-drawer]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = qsa('a[href], button:not([tabindex="-1"]), summary, input', drawer.querySelector('.esh-drawer__panel')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ---------- sport finder ---------- */
  qsa('[data-esh-finder]').forEach(function (form) {
    var sel = form.querySelector('[data-esh-sport]');
    var pills = qsa('[data-esh-need]', form);
    var go = form.querySelector('[data-esh-finder-go]');
    var cta = form.querySelector('[data-esh-finder-cta]');
    var note = form.querySelector('[data-esh-finder-note]');
    if (!sel || !go) return;
    var need = { term: '', label: 'Everything' };
    function update() {
      var o = sel.options[sel.selectedIndex];
      if (!o) return;
      var name = o.getAttribute('data-name');
      if (!need.term) {
        go.href = o.getAttribute('data-url');
        cta.textContent = 'Show all ' + name + ' equipment';
        note.textContent = o.getAttribute('data-count') + ' products in ' + name;
      } else {
        go.href = '/search?type=product&q=' + encodeURIComponent(name + ' ' + need.term);
        cta.textContent = 'Show ' + name + ' · ' + need.label;
        note.textContent = 'Searches ' + name + ' for ' + need.label.toLowerCase();
      }
    }
    sel.addEventListener('change', update);
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        need = { term: p.getAttribute('data-esh-need'), label: p.getAttribute('data-label') };
        update();
      });
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); window.location.href = go.href; });
    update();
  });

  /* ---------- tabs ---------- */
  qsa('[data-esh-tabs]').forEach(function (root) {
    var tabs = qsa('[role="tab"]', root);
    function activate(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.setAttribute('tabindex', on ? '0' : '-1');
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
      try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (err) {}
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); activate(n, true); }
      });
    });
  });

  /* ---------- quick add (single-variant cards) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-esh-add]');
    if (!b || b.classList.contains('is-busy')) return;
    var label = b.querySelector('span') || b;
    var id = parseInt(b.getAttribute('data-esh-add'), 10);
    b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); label.textContent = 'Adding…';
    var done = function (cls, txt) {
      b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); b.classList.add(cls); label.textContent = txt;
      setTimeout(function () { b.classList.remove(cls); label.textContent = 'Add to basket'; }, 2400);
    };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { done('is-error', 'Try again'); return; }
        done('is-done', 'Added ✓');
        refreshCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'esh' } }));
      })
      .catch(function () { done('is-error', 'Try again'); });
  });
})();